/* eslint-disable import/no-cycle */
import { combineReducers } from 'redux';

import { IS_ADMIN } from '@/services/Constants';
import { adminReducers } from '@/admin/rootState';
import { reducers } from '@/rootState';

const createRootReducer = () => {
	if (IS_ADMIN) {
		return combineReducers(adminReducers);
	}

	return combineReducers(reducers);
};

export default createRootReducer;
